var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTictactoeGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_153)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 42.8475C14.3775 42.8475 15.8911 41.3443 15.8911 39.4782C15.8911 37.6225 14.3775 36.1089 12.5218 36.1089C10.6661 36.1089 9.15247 37.6225 9.15247 39.4782C9.15247 41.3339 10.6661 42.8475 12.5218 42.8475ZM12.5218 37.6639C13.517 37.6639 14.3361 38.4829 14.3361 39.4782C14.3361 40.4734 13.517 41.2924 12.5218 41.2924C11.5265 41.2924 10.7075 40.4734 10.7075 39.4782C10.7075 38.4829 11.5265 37.6639 12.5218 37.6639Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4782 11.8912C45.3443 11.8912 46.8475 10.3776 46.8475 8.52183C46.8475 6.6661 45.3339 5.1525 43.4782 5.1525C41.6225 5.1525 40.1089 6.6661 40.1089 8.52183C40.1089 10.3776 41.6225 11.8912 43.4782 11.8912ZM43.4782 6.70757C44.4838 6.70757 45.2925 7.51621 45.2925 8.52183C45.2925 9.51708 44.4735 10.3361 43.4782 10.3361C42.483 10.3361 41.664 9.51708 41.664 8.52183C41.664 7.52658 42.483 6.70757 43.4782 6.70757Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39095 11.6527C9.54646 11.8082 9.74344 11.8808 9.94041 11.8808C10.1374 11.8808 10.3344 11.8082 10.4899 11.6527L12.5218 9.62073L14.5538 11.6527C14.7093 11.8082 14.9063 11.8808 15.1033 11.8808C15.3002 11.8808 15.4972 11.8082 15.6527 11.6527C15.9534 11.352 15.9534 10.8544 15.6527 10.5538L13.6208 8.52181L15.6527 6.48984C15.9534 6.18919 15.9534 5.69157 15.6527 5.39092C15.3521 5.09027 14.8545 5.09027 14.5538 5.39092L12.5218 7.42289L10.4899 5.39092C10.1892 5.09027 9.6916 5.09027 9.39095 5.39092C9.0903 5.69157 9.0903 6.18919 9.39095 6.48984L11.4229 8.52181L9.39095 10.5538C9.0903 10.8544 9.0903 11.352 9.39095 11.6527Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2225 0H35.7443H20.2557H4.77754C4.35248 0 4 0.352484 4 0.777538V16.2557V31.7339V47.2225C4 47.6475 4.35248 48 4.77754 48H20.2557H35.7339H51.2225C51.6475 48 52 47.6475 52 47.2225V31.7443V16.2557V0.777538C52 0.352484 51.6475 0 51.2225 0ZM19.4782 46.4449H5.55508V32.5218H19.4782V46.4449ZM19.4782 30.9564H5.55508V17.0333H19.4782V30.9564ZM19.4782 15.4782H5.55508V1.55508H19.4782V15.4782ZM34.9564 46.4449H21.0333V32.5218H34.9564V46.4449ZM34.9564 30.9667H21.0333V17.0333H34.9564V30.9667ZM34.9564 15.4782H21.0333V1.55508H34.9564V15.4782ZM50.4449 46.4449H36.5218V32.5218H50.4449V46.4449ZM50.4449 30.9667H36.5218V17.0333H50.4449V30.9667ZM50.4449 15.4782H36.5218V1.55508H50.4449V15.4782Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 27.3693C29.8557 27.3693 31.3693 25.8557 31.3693 24C31.3693 22.1443 29.8557 20.6307 28 20.6307C26.1443 20.6307 24.6307 22.1443 24.6307 24C24.6307 25.8557 26.1443 27.3693 28 27.3693ZM28 22.1858C28.9953 22.1858 29.8143 23.0048 29.8143 24C29.8143 24.9953 28.9953 25.8143 28 25.8143C27.0048 25.8143 26.1858 24.9953 26.1858 24C26.1858 23.0048 27.0048 22.1858 28 22.1858Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3793 39.4782L40.3473 41.5102C40.0467 41.8108 40.0467 42.3084 40.3473 42.6091C40.5028 42.7646 40.6998 42.8372 40.8968 42.8372C41.0937 42.8372 41.2907 42.7646 41.4462 42.6091L43.4782 40.5771L45.5102 42.6091C45.6657 42.7646 45.8626 42.8372 46.0596 42.8372C46.2566 42.8372 46.4536 42.7646 46.6091 42.6091C46.9097 42.3084 46.9097 41.8108 46.6091 41.5102L44.5771 39.4782L46.6091 37.4462C46.9097 37.1456 46.9097 36.648 46.6091 36.3473C46.3084 36.0467 45.8108 36.0467 45.5102 36.3473L43.4782 38.3793L41.4462 36.3473C41.1456 36.0467 40.648 36.0467 40.3473 36.3473C40.0467 36.648 40.0467 37.1456 40.3473 37.4462L42.3793 39.4782Z",
    fill: "#5DEE7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_153",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTictactoeGreen);
export default __webpack_public_path__ + "static/media/tictactoe-green.cdab397a447199d37fef2b27dab08bc3.svg";
export { ForwardRef as ReactComponent };